import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./ModalTurnosKin.css";
import DatosTurnoKin from "./DatosTurnoKin";

const ModalTurnosKin = ({ turno, dissmiss, danger, confirmarTurnoModal }) => {
  const { turnosDisponiblesState } = useContext(PortalContext);

  let anterior = 0;

  return (
    <React.Fragment>
      <div className="ptur-modalTurnosKin-container">
        <div className="ptur-modalTurnosKin-header">
          <HeaderModal
            titulo={turno.infoSesion}
            dissmiss={dissmiss}
            danger={danger}
            marginRight={"15px"}
          />
        </div>
        <div>
          <span className="ptur-modalTurnosKin-texto">
            Plan de 10 turnos de kinesiologia
          </span>
        </div>
        <div className="ptur-modalTurnosKin-body">
          {turnosDisponiblesState.turnosDisponibles.turnosData.turnos?.map(
            (item, index) => {
              if (anterior === 10) {
                anterior = 0;
              }
              anterior = anterior + 1;
              return (
                <React.Fragment key={index}>
                  {turno.nroSesion === item.nroSesion ? (
                    <div className="ptur-modalTurnosKin-cardBody">
                      <DatosTurnoKin
                        nTurno={anterior}
                        centro={item.centro}
                        hora={item.hora}
                        fecha={item.fecha}
                        medico={item.medico}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );
            }
          )}
        </div>
        <div style={{ height: "10%" }}>
          <button
            onClick={() => confirmarTurnoModal(turno)}
            className="ptur-cardTurnoKin-btn bgc-primary c-white rb18m btnseba"
            style={{ width: "80%", margin: "auto" }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModalTurnosKin;
